import { FETCH_STAGES_SUCCEEDED } from './stages.constant';
import { stagesInitialState } from './stages.initialState';
import { pathOr } from 'ramda';

export const stageReducer = (state = stagesInitialState, action) => {
	switch (action.type) {
		case FETCH_STAGES_SUCCEEDED: {
			const data = pathOr([], ['payload', 'data'], action);
			const newEntities = data.reduce((accummulator, value) => {
				accummulator[value._id] = value;
				return accummulator;
			}, {});

			return {
				...state,
				entities: newEntities,
			};
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/stages/stages.reducer.js